import { render, staticRenderFns } from "./Webshare.vue?vue&type=template&id=4e13bb12"
import script from "./Webshare.vue?vue&type=script&lang=js"
export * from "./Webshare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports